// src/components/Searchable.jsx
import { HStack } from "@chakra-ui/react";
import { Form, UI } from "components";
import { useEffect, useState, useRef } from "react";

export default function Searchable({ value = "", onChange = () => {}, children, minLength = 3, ...props }) {
    const [internalValue, setInternalValue] = useState(value);
    const timeoutRef = useRef(null);

    // Sincroniza valor externo para interno ao mudar a prop value
    useEffect(() => {
        setInternalValue(value);
    }, [value]);

    const handleChange = event => {
        const searchText = event.target.value;
        setInternalValue(searchText);

        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            if (searchText.length >= minLength || searchText.length === 0) {
                onChange(searchText);
            }
        }, 1000);
    };

    return (
        <HStack
            borderRadius={4}
            p={2}
            backgroundColor="rgba(0,0,0,0.05)"
            border="1px solid"
            borderColor="rgba(0,0,0,0.1)"
            minW="300px"
            {...props}
        >
            <UI.Icon name="search" ml={2} fontSize="25px" color="GrayText" />
            <Form.Text
                type="search"
                autoComplete="off"
                value={internalValue}
                onChange={handleChange}
                fontWeight="bold"
                border={0}
                {...props}
            />
            {children}
        </HStack>
    );
}
